import React, { useState } from 'react'
import Swal from 'sweetalert2';
import instance from '../Config/AxiosConfig';
import Cookies from 'js-cookie';
function AddProjects({ handleProjectModalClose, createProj, setCreateProj, showProjectModal }) {


    const [errors, setErrors] = useState({});
    const [success, setSuccess] = useState('');




    const [formData, setFormData] = useState({
        name: '',
        description: '',
        startDate: '',
        endDate: '',
        status: 'Accepted'
    });


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };
    const validateForm = () => {
        const errors = {};
        if (!formData.name) errors.name = 'Project name is required';
        if (!formData.description) errors.description = 'Project description is required';
        if (!formData.startDate) errors.startDate = 'Start date is required';
        if (!formData.endDate) errors.endDate = 'End date is required';
        return errors;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const token = Cookies.get('token');
        const data = new FormData();
        data.append('name', formData.name);
        data.append('description', formData.description);
        data.append('startDate', formData.startDate);
        data.append('endDate', formData.endDate);
        data.append('status', formData.status);

        for (let [key, value] of data.entries()) {
            console.log(`${key}: ${value}`);
        }


        try {

            const response = await instance.post('/projects/add', data, token);


            if (response.status === 200) {

                Swal.fire({

                    text: " Project added successfully!",
                    icon: "success"
                });

                setFormData({ name: '', description: '', startDate: '', endDate: '', status: 'Accepted' });

                // setCreateProj(response)

                setErrors({});


                if (showProjectModal) {
                    handleProjectModalClose();
                }

            } else {
                Swal.fire({
                    title: "Error!",
                    text: " Failed to add project.",
                    icon: "error"
                });
                console.error('response status:', response.status);
                setErrors({ form: 'Failed to add project.  error from server.' });
            }
        }
        catch (error) {


            if (error.response) {


                if (error.response.data && error.response.data.error) {
                    setErrors(error.response.data.error);
                } else {
                    setErrors({ form: 'Failed to add project Please try again later' });
                }
            } else if (error.request) {

                setErrors({ form: 'No response from server' });
            } else {

                setErrors({ form: error.message });
            }
        }
    };





    return (
        <>
            {errors.form && <p style={{ color: 'red' }}>{errors.form}</p>}
            {success && <p style={{ color: 'green' }}>{success}</p>}

            <form className="row g-3" onSubmit={handleSubmit}>
                {/* Project information */}
                <div className="col-12">
                    <label className="form-label">Project name</label>
                    <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="project name (Required)"
                    />
                    {errors.name && <small style={{ color: 'red' }}>{errors.name}</small>}

                </div>

                {/* Project description */}
                <div className="col-12">
                    <label className="form-label">About project</label>
                    <textarea
                        className="form-control"
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        rows={3}
                        placeholder="Description (Required)"
                    />
                    {errors.description && <small style={{ color: 'red' }}>{errors.description}</small>}

                </div>

                {/* Divider */}
                <hr />

                {/* Date fields */}
                <div className="col-12">
                    <h5 className="card-title mb-0">Date</h5>
                </div>

                <div className="col-sm-6">
                    <label className="form-label">Start Date</label>
                    <div className="input-group">

                        <input
                            type="date"
                            className="form-control"
                            name="startDate"
                            value={formData.startDate}
                            onChange={handleChange}
                            placeholder="JJ/MM/AAAA"
                        />
                    </div>
                    {errors.startDate && <small style={{ color: 'red' }}>{errors.startDate}</small>}
                </div>

                <div className="col-sm-6">
                    <label className="form-label">End Date</label>
                    <div className="input-group">

                        <input
                            type="date"
                            className="form-control"
                            name="endDate"
                            value={formData.endDate}
                            onChange={handleChange}
                            placeholder="JJ/MM/AAAA"
                        />
                    </div>
                    {errors.endDate && <small style={{ color: 'red' }}>{errors.endDate}</small>}
                </div>



                {/* Button  */}
                <div className="col-12 text-end mt-5">
                    <button type="submit" className="btn btn-primary mb-0" >Create a project</button>
                </div>


            </form>





        </>
    )
}

export default AddProjects